import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const BusquedaBitacoraHallazgoService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Bitacora/BusquedaBitacoraHallazgo", values, customConfig);

        return resultado;

    } catch (error) {

        console.log(error);

    }

};

export { BusquedaBitacoraHallazgoService };
